import React from 'react';

import withAppState from '../mobx/withAppState'
import { GuidEmpty, SplitType } from '../lib/constants';

import SplitByItem from './SplitByItem';

import refreshIcon from './../assets/img/refresh/Refresh.svg'
import plusIcon from '../assets/img/plus.svg';
import refresh from '../assets/img/refresh.svg';


const elementPlus = <img src={plusIcon} alt="plus" />;

const refreshButton = (props) => {
    return (
      <div className="refresh-link">
          <a
            target="_blank"
            rel="noopener noreferrer"
            className={`refresh-link-button ${props.refreshButtonLoading === true ? 'refreshing' : ''}`}
            onClick={async () => await props.refreshTable()}
          >
            <img src={refresh} alt="refresh" />
            <span>
              {props.refreshButtonLoading === false ? "Refresh" : "Refreshing"}
            </span>
          </a>
        
      </div>
    );
};

const getItemComparisonStringElements = item => {
  let comparisonStringElements = [];
  if (item.additions.length > 0) {
    comparisonStringElements.push(item.productId + "|" + item.quantity + "|" + item.cost);
    item.additions.forEach(addition => comparisonStringElements.push(getItemComparisonStringElements(addition)));
  }
  else {
    comparisonStringElements.push(item.productId);
  }

  return comparisonStringElements;
}

const itemsMatch = (item, otherItem) => {
  let itemComparisonStringElements = getItemComparisonStringElements(item);
  let otherItemComparisonStringElements = getItemComparisonStringElements(otherItem);

  if (itemComparisonStringElements.length != otherItemComparisonStringElements.length)
    return false;

  return itemComparisonStringElements.sort().join('|') === otherItemComparisonStringElements.sort().join('|')
}

const splitBillInfo = (props, bill, splitBillInfoRef) => {
  let totalRemaining = 0;

  if (bill.splitBill.splitType === SplitType.SplitByItem) {
    let remainingItems = bill.availableItems;
    for (let i = 0; i < remainingItems.length; i++) {
      totalRemaining += remainingItems[i].cost;
      let additions = remainingItems[i].additions;
      for (let j = 0; j < additions.length; j++) {
        totalRemaining += additions[j].cost;
      }
    }
  } else {
    totalRemaining = bill.outstandingBalance - props.billTotal;
  }
  return (
    <div className="split-bill-info" ref={splitBillInfoRef}>
      <ul className="bill-item-block bill-category-subtotal bill-divider bill-total">
        <li className="bill-item-text">
          <p>You're paying</p>
        </li>
        <li className="bill-item-amount">
          <p>{props.currency.symbol + props.billTotal.toFixed(2)}</p>
        </li>
      </ul>
      <ul className="bill-item-block bill-category-subtotal bill-divider bill-total">
        <li className="bill-item-text">
          <p>Remaining</p>
        </li>
        <li className="bill-item-amount">
          <p>{`${props.currency.symbol + (totalRemaining).toFixed(2)}`}
          </p>
        </li>
      </ul>
    </div>
  );
};

class Bill extends React.Component {
  constructor() {
    super();
    this.splitBillInfoRef = React.createRef();
    this.iconRef = React.createRef();
  }

  componentDidMount() {
    
    !!this.iconRef.current && this.iconRef.current.scrollIntoView({
      inline: 'center'
    });

    if (!this.props.bill || this.props.bill.length === 0) {
      this.props.handleNoBill();
    } else {
      this.props.startRefreshBillCycle();
    }
  }

  render() {
    if (!!this.props.bill && this.props.bill.length > 0) {
      const { bill: bills, selectedSplitIndex } = this.props;
      const bill = bills[0];
      let items = JSON.parse(JSON.stringify(bill.items));

      const { splitBill: { splitType, splits } } = bill;
      const availableItems = splitType === SplitType.SplitByItem
        ? bill.availableItems
        : null;

      const isSplitBill = splitType !== SplitType.None;
      var currencySymbol = !!this?.props?.currency?.symbol ? this.props.currency.symbol : "€"; 

        if (splitType !== SplitType.SplitByItem) {
            items = bill.groupedItems;
      }

      const MainBill = () => {
        if (isSplitBill) {
          let selected = selectedSplitIndex === null;
          return (
            <div
              ref={selected ? this.iconRef : null}
              key="main-bill"
              className={`split-bill-icon summary-tab ${
                (this.props.assignedSplitIndex === null ? 'user' : '')
                + (selected ? 'selected ' : '')
                }`}
              onClick={() => {
                this.props.setSelectedSplitIndex(null)
              }}
            >
              Bill
            </div>
          );
        }
        return null;
      };

      const SplitBills = () => {
        if (!isSplitBill) {
          return null;
        }

        return bill.splitBill.splits.map((split, index) => {
          if (split.sessionToken === GuidEmpty) {
            return null;
          }
          let isSelected = index === selectedSplitIndex;
          const { name, paid } = split;
          return (
            <div
              ref={isSelected ? this.iconRef : null}
              key={index}
              className={`split-bill-icon user split-bill-icon-${(index + 1) % 4 } ${(index ===
                this.props.assignedSplitIndex ? 'user user-assigned-split ' : '')
                + (isSelected ? 'selected ' : '')
                + (paid === true ? 'paid ' : '')}`}
              onClick={async () => {
                this.props.setSelectedSplitIndex(index);
                await this.props.refreshTable(false);
                if (!!this.splitBillInfoRef.current) {
                  this.splitBillInfoRef.current.scrollIntoView({
                    block: 'end'
                  });
                }
              }}
            >
              {name}
            </div>
          );
        });
      };

      const AddSplit = () => {
        if (
          this.props.assignedSplitIndex === null &&
          (bill.splitBill.splitType === SplitType.SplitByItem ||
            splits.some(s => s.sessionToken === GuidEmpty))
        )
          return (
            <div
              className={`split-bill-icon`}
              onClick={this.props.handleJoinSplitButton}
            >
              {elementPlus}
            </div>
          );

        return null;
      };

      const transformAdditionNames = (nestingLevel, array, item, index) => {
        item.additions.forEach((addition, adIndex) => {
          itemCosts += parseFloat(addition.cost);
          totalCosts += parseFloat(addition.cost);
          const operator = addition.quantity >= 0 ? '+' : '-';
          array.push(
            <p
              key={`${index}-n${adIndex}`}
              className="item-additions"
              style={{ paddingLeft: (nestingLevel * 15) + 'px' }}
            >
              {`${operator} ${addition.name} ${
                !!addition.description ? `${addition.description}` : ``
                }`}
            </p>
          );

          transformAdditionNames(nestingLevel + 1, array, addition, adIndex);

        });
      }

      const transformAdditionQuantities = (nestingLevel, array, item, index) => {
        item.additions.forEach((addition, adIndex) => {
          array.push(
            <p
              key={`${index}-q${adIndex}`}
              className="item-additions"
            >
              {addition.quantity >= 2 ? addition.quantity : (<span>&nbsp;</span>)}
            </p>
          );
          transformAdditionQuantities(nestingLevel + 1, array, addition, adIndex);
        });
      }

      const transformAdditionCosts = (nestingLevel, array, item, index) => {
        item.additions.forEach((addition, adIndex) => {
          array.push(
            <p
              key={`${index}-c${adIndex}`}
              className="item-additions"
            >
                  {addition.cost !== 0  ? `${currencySymbol + addition.cost.toFixed(2)}` : (<span>&nbsp;</span>)}
            </p>
          );
          transformAdditionCosts(nestingLevel + 1, array, addition, adIndex);
        });
      }

      const transformAdditions = (item, index) => {

        const result = { additionNames: [], additionQuantities: [], additionCosts: [] };

        transformAdditionNames(0, result.additionNames, item, index);
        transformAdditionQuantities(0, result.additionQuantities, item, index);
        transformAdditionCosts(0, result.additionCosts, item, index);

        return result

      }

      var itemCosts = 0.0;
      var totalCosts = 0.0;
      let isSplitBillTab = this.props.selectedSplitIndex !== null;      

      return (
        <div className={`bill-wrapper ${isSplitBill ? 'no-pad-top' : ''}`}>
          {isSplitBill ? (
            <div className="split-bill-outer">
              <div className="scrollable-container">
                <div className="scrollable-outer">
                  <div className="scrollable-inner">                    
                    <MainBill />
                    <SplitBills />
                    <AddSplit />
                  </div>
                </div>
              </div>
              {isSplitBillTab ? (
                <div className="split-bill-info-wrapper">
                  {splitBillInfo(this.props, bill)}
                </div>
              ) : null}
            </div>
          ) : null}
          <div className="bill-title-block">
            <div className="bill-title-block-inner">
                <div className="title-column">
                  <div className="title">TABLE ORDER</div>
                </div>
                <div className="title-column btn-container ">
                  {refreshButton(this.props)}
                </div>
              </div>
            </div>
          <div
            className={`bill ${
              isSplitBill && isSplitBillTab
                ? 'split-active'
                : isSplitBill
                  ? 'split-summary'
                  : ''
              }`}
          >
            {bill.splitBill.splitType === SplitType.SplitByItem && isSplitBillTab ? (
              <SplitByItem
                split={splits[selectedSplitIndex]}
                selectedSplitIndex={selectedSplitIndex}
                availableItems={availableItems}
                splitBillInfoRef={this.splitBillInfoRef}
                currency={this.props.currency}
              />
            ) : (
                items.map((item, index) => {
                  var itemName = item.name;
                  var description = item.description;
                  var quantity = item.quantity;
                  var cost = parseFloat(item.cost);
                  var { additionNames, additionQuantities, additionCosts } = transformAdditions(item, index);

                  itemCosts += parseFloat(cost);
                  totalCosts += parseFloat(cost);

                  let splitBillInfoRef =
                    index === 0 ? this.splitBillInfoRef : null;

                  return (
                    <div className="bill-item-block-container">                    
                      <ul
                        ref={splitBillInfoRef}
                        className="bill-item-block bill-category-subtotal"
                        key={index}
                      >
                        <li className="bill-item-text">
                          <p className="item-name">
                            {' '}
                            {`${itemName} ${
                              !!description ? `${description}` : ``
                              }`}
                          </p>
                          {additionNames}
                        </li>
                        <li className="bill-item-quantity">
                          <p>{quantity}</p>
                          {additionQuantities}
                        </li>
                        <li className="bill-item-amount">
                                <p>{currencySymbol + cost.toFixed(2)}</p>
                          {additionCosts}
                        </li>
                      </ul>
                    </div>
                  );
                })
              )}

            {(bill.splitBill.splitType !== SplitType.SplitByItem || !isSplitBillTab) &&
              <>
              <div className="bill-item-block-container">  
                <ul
                  style={{ fontWeight: 'bold' }}
                  className="bill-item-block bill-category-subtotal bill-divider bill-total"
                >
                  <li className="bill-item-text">
                    <p>Subtotal</p>
                  </li>
                  <li className="bill-item-quantity"></li>
                  <li className="bill-item-amount">
                    <p>{`${currencySymbol + itemCosts.toFixed(2)}`}</p>
                  </li>
                </ul>
              </div>

                {bill.discounts.map((discount, index) => {
                  totalCosts -= parseFloat(discount.amount);
                  return (
                    <div className="bill-item-block-container">  
                      <ul
                        className="bill-item-block bill-category-subtotal bill-divider"
                        key={index}
                      >
                        <li className="bill-item-text">
                          {
                            <p>{`${discount.name} ${
                              !!discount.percentage
                                ? `- ${discount.percentage}% off`
                                : ''
                              }`}</p>
                          }
                        </li>
                        <li className="bill-item-quantity"></li>
                        <li className="bill-item-amount">
                          <p>{currencySymbol + discount.amount.toFixed(2)}</p>
                        </li>
                      </ul>
                    </div>
                  );
                })}

                {bill.promotions.filter(p => p.hasItems === false).map((promotions, index) => {
                  totalCosts -= parseFloat(promotions.amount);
                  return (                    
                  <div className="bill-item-block-container">  
                    <ul
                      className="bill-item-block bill-category-subtotal bill-divider"
                      key={index}
                    >
                      <li className="bill-item-text">
                        <p>{promotions.name}</p>
                      </li>
                      <li className="bill-item-quantity"></li>
                      <li className="bill-item-amount">
                        <p>{currencySymbol}-{promotions.amount.toFixed(2)}</p>
                      </li>
                    </ul>
                  </div>
                  );
                })}

                {bill.payments.map((payment, index) => {
                  totalCosts -= parseFloat(payment.amount);
                  return (
                  <div className="bill-item-block-container">  
                    <ul
                      className="bill-item-block bill-category-subtotal bill-divider"
                      key={index}
                    >
                      <li className="bill-item-text">
                        <p>Payment - {payment.paymentMethod}</p>
                      </li>
                      <li className="bill-item-quantity"></li>
                      <li className="bill-item-amount">
                        <p>{currencySymbol}-{payment.amount.toFixed(2)}</p>
                      </li>
                    </ul>
                  </div>
                  );
                })}

                {bill.charges.map((charge, index) => {
                  totalCosts += parseFloat(charge.amount);
                  return (
                  <div className="bill-item-block-container">  
                    <ul
                      className="bill-item-block bill-category-subtotal bill-divider"
                      key={index}
                    >
                      <li className="bill-item-text">
                        <p>Service charge</p>
                      </li>
                      <li className="bill-item-quantity"></li>
                      <li className="bill-item-amount">
                        <p>{currencySymbol + charge.amount.toFixed(2)}</p>
                      </li>
                    </ul>
                  </div>
                  );
                })}

              <div className="bill-item-block-container">  
                <ul
                  style={{ fontWeight: 'bold' }}
                  className="bill-item-block bill-category-subtotal bill-divider bill-total"
                >
                  <li className="bill-item-text">
                    <p>Grand total</p>
                  </li>
                  <li className="bill-item-quantity"></li>
                  <li className="bill-item-amount">
                  <p>{currencySymbol + totalCosts.toFixed(2)}</p>
                  </li>
                </ul>
              </div>
              </>
            }

            {!isSplitBill &&
              bill.providerValues['CanApplyVouchers'] === 'True'
              ? (
                <div className="bill-item-block-container">  
                  <div className="bill-item-block">  
                    <p className="apply-voucher-cta">
                      <a
                        className={`text-cta`}
                        onClick={this.props.handleApplyVoucherButton}
                      >
                        Apply Voucher
                      </a>
                    </p>
                  </div>
                </div>
              ) : null}
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}

export default withAppState(Bill,
  {
    mobXProps: ({
      billTotal,
      bill,
      selectedSplitIndex,
      assignedSplitIndex,
      refreshButtonLoading,
    }) => ({
      billTotal,
      bill,
      selectedSplitIndex,
      assignedSplitIndex,
      refreshButtonLoading,
    }),
    mobXActions: ({
      startRefreshBillCycle,
      setSelectedSplitIndex,
      refreshTable
      
    }) => ({
      startRefreshBillCycle,
      setSelectedSplitIndex,
      refreshTable
    })
  }
);